module.exports = __webpack_public_path__ + "img/icon5-1.6fbe5d36.png";